import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { DriverSelectComponent } from 'src/app/_components/remote-action-step/driver-select/driver-select.component';

@Injectable()
export class DriverSelectRemoteActionBuilderUiStep
  implements GenericRemoteActionBuilderUIStep
{
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(this.constructor.name, '- getComponent called');
    return DriverSelectComponent;
  }

  public isVisible(currentData: any): boolean {
    // Hide Step if car select QR Code contained private trip flag
    if (currentData.privattrip === true) {
      return false;
    }
    // Hide Step if car select QR Code contained dpflag flag
    if (currentData.dpflag) {
      return false;
    }

    return true;
  }
}
